/* Copyright 2016-2022
   Kabandy
   Author: Cedric Hoarau
 */

import { UrlParam } from "../System";

let _clientId : string = "";
let _clientSecret : string = "";

export namespace OAuthClientConf {
    export function Init() {
        // Client ID
        _clientId = process.env.KAB_CLIENT_ID || "";
        const clientIdFromUrl: string | null = UrlParam.Get(window.location.search, "clientId");
        if (clientIdFromUrl) {
            // @ts-ignore
            _clientId = DOMPurify.sanitize(clientIdFromUrl, { USE_PROFILES: { html: false } });
        }

        // Client Secret
        _clientSecret = process.env.KAB_CLIENT_SECRET || "";
        const clientSecretFromUrl: string | null = UrlParam.Get(window.location.search, "clientSecret");
        if (clientSecretFromUrl) {
            // @ts-ignore
            _clientSecret = DOMPurify.sanitize(clientSecretFromUrl, { USE_PROFILES: { html: false } });
        }
    }

    export function ClientId() {
        return _clientId;
    }
    
    export function ClientSecret() {
        return _clientSecret;
    }
}
